<!-- Card Content -->
<p-panel class="collapsible-panel"
  header="{{ titleText | translate }}"
  styleClass="{{ contentClass }}"
  [toggleable]="false"
  [collapsed]="collapsed">
  @if (header_template !== undefined) {
    <ng-template
      pTemplate="header">
      <ng-container *ngTemplateOutlet="header_template"></ng-container>
    </ng-template>
  }
  <ng-template pTemplate="icons">
    @if (toggleable && menuItems?.length) {
      <medsurf-design-input-menu
        [formField]="false"
        [name]="'panel_menu'"
        [tooltipLabel]="tooltipLabel"
        [menuClass]="menuClass"
        [buttonInputClass]="buttonClass"
        [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
        [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
      [loadMenuItems]="addCollapseMenuItem"></medsurf-design-input-menu>
    }
    @if (toggleable && !menuItems?.length) {
      <button medsurf-design-input-button
        [id]="'panel_button'"
        [title]="getCollapsedLabel() | translate"
        [iconClass]="getCollapsedClass()"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
      (click)="toggleIsMinimized()"></button>
    }
  </ng-template>
  <ng-template pTemplate="content">
    @if (!collapsed) {
      <ng-content></ng-content>
    }
  </ng-template>
</p-panel>